import { Menu } from "antd";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  CloudServerOutlined,
  SyncOutlined,
  UsergroupAddOutlined,
  RocketOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { brand } from "@/theme";

const nav = [
  { key: "/clouds", icon: <CloudServerOutlined />, label: "Connected clouds" },
  { key: "/mappings", icon: <UsergroupAddOutlined />, label: "User mappings" },
  { key: "/migrate", icon: <RocketOutlined />, label: "Start migration" },
  { key: "/jobs", icon: <SyncOutlined />, label: "Migrations" },
  { key: "/settings", icon: <SettingOutlined />, label: "Settings" },
];

export function Sidebar() {
  const loc = useLocation();
  const nav2 = useNavigate();
  const active = nav.find((n) => loc.pathname.startsWith(n.key))?.key ?? nav[0].key;

  return (
    <aside
      style={{
        width: 232,
        height: "100vh",
        position: "sticky",
        top: 0,
        background: brand.surface,
        borderRight: `1px solid ${brand.border}`,
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
      }}
    >
      <NavLink
        to="/jobs"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "14px 18px",
          height: 52,
          borderBottom: `1px solid ${brand.border}`,
          textDecoration: "none",
          color: brand.text,
        }}
      >
        <span
          style={{
            width: 26,
            height: 26,
            borderRadius: 6,
            background: brand.primary,
            color: "#fff",
            display: "grid",
            placeItems: "center",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: "-0.02em",
          }}
        >
          CF
        </span>
        <div style={{ lineHeight: 1.1 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>CloudFuze</div>
          <div style={{ fontSize: 10.5, color: brand.textMuted, letterSpacing: "0.03em" }}>
            EMAIL MIGRATION
          </div>
        </div>
      </NavLink>

      <div style={{ padding: "12px 0", flex: 1, overflow: "auto" }}>
        <div
          style={{
            padding: "0 18px 8px",
            fontSize: 10.5,
            color: brand.textMuted,
            letterSpacing: "0.06em",
            fontWeight: 600,
            textTransform: "uppercase",
          }}
        >
          Operations
        </div>
        <Menu
          mode="inline"
          selectedKeys={[active]}
          onClick={({ key }) => nav2(key as string)}
          items={nav.map((n) => ({ key: n.key, icon: n.icon, label: n.label }))}
          style={{ border: "none", background: "transparent" }}
        />
      </div>

      <div
        style={{
          padding: "12px 18px",
          borderTop: `1px solid ${brand.border}`,
          fontSize: 11,
          color: brand.textMuted,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: brand.success,
            }}
          />
          Migration engine online
        </div>
      </div>
    </aside>
  );
}
